import { Header } from "@/components/landing/Header";
import { Hero } from "@/components/landing/Hero";
import { TrustMarquee } from "@/components/landing/TrustMarquee";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { Situations } from "@/components/landing/Situations";
import { Benefits } from "@/components/landing/Benefits";
import { Testimonials } from "@/components/landing/Testimonials";
import { FAQ } from "@/components/landing/FAQ";
import { Footer } from "@/components/landing/Footer";

export default function LandingPage() {
  return (
    <div className="bg-stone-50 min-h-screen" data-testid="landing-page">
      <Header />
      <Hero />
      <TrustMarquee />
      <HowItWorks />
      <Situations />
      <Benefits />
      <Testimonials />
      <FAQ />
      <Footer />
    </div>
  );
}
